import { THEORY_SUBJECT_ID } from '../../constants/subjects';
import { AttemptMode } from './api/useMultipleChoiceAssessments';

/**
 * The mode attempts of a subject are answered in, or undefined when the subject offers
 * both and the choice is the user's to make. Theory is the only subject sat on paper;
 * aptitude and English are answered on screen.
 */
function useAttemptMode(subjectId: string): AttemptMode | undefined {
  return subjectId === THEORY_SUBJECT_ID ? undefined : 'interactive';
}

export { useAttemptMode };
